import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as e } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconPlayCircleFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(l).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function _(a, i, r, h, g, t) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--play-circle-filled"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Play Circle Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      e("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M.563 6a5.437 5.437 0 1 0 10.875 0A5.437 5.437 0 0 0 .563 6Zm4.231 2.386a.437.437 0 0 0 .45-.022l3-2a.438.438 0 0 0 0-.728l-3-2a.438.438 0 0 0-.68.364v4c0 .162.088.31.23.386Zm.644-1.203V4.818L7.212 6 5.438 7.183Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, m),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, [...i[1] || (i[1] = [
        e("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const C = /* @__PURE__ */ c(u, [["render", _]]);
export {
  C as default
};
//# sourceMappingURL=play-circle-filled.js.map
